<ul class="tabs" [class.-bordered]="!hideBorder">
  <li *ngFor="let tab of tabs$ | async" [ngClass]="tab.itemClass" routerLinkActive #tabActive="routerLinkActive">
    <a [routerLink]="tab.url" class="tab" [class.active]="tabActive.isActive" (click)="tab.emitClick()">
      {{ tab.label }}
    </a>
    <!--
      Invisible links so that routerLinkActive above (which considers any descendant
      RouterLink) also treats this tab as active while on one of these other routes -
      used by tabs whose content was split into a separate sibling route but should
      still visually read as part of this tab (see TabComponent.activeUrlAliases).
    -->
    <a
      *ngFor="let aliasUrl of tab.activeUrlAliases"
      [routerLink]="aliasUrl"
      hidden
      tabindex="-1"
      aria-hidden="true"
    ></a>
  </li>
</ul>
<div *ngIf="!hideOutlet">
  <router-outlet></router-outlet>
</div>
